<template>
    <a class="book_list_item clearFix" :href="item.book_list_url || 'javascript:;'">
        <div class="img_contain fl">
            <img  v-lazy="item.book_attach_url" alt="">
            <div class="book_count">共{{item.creation_count}}本书</div>
        </div>
        <div class="book_conent_title">
            <p class="omit">{{item.book_title}}</p>
            <div class="book_conent_title_bottom">{{item.book_content}}</div>
            <div class="comment_total">
                <div class="hert" :class="{collect_click:item.is_wish}"></div>
                <span>{{item.wish_num}}</span>
                <div class="comment_icon"></div>
                <span>{{item.comment_num}}</span>
            </div>
        </div>
         <popup :pop-obj="errobj" v-if="errobj.type" @confirm-click="confirmEvent"></popup>
    </a>
</template>
<script>
import popup from './popup.vue'

export default {
    name: 'booklistItem',
    props: ['conent'],
    components:{popup},
    data() {
        return {
            item: this.conent,
            errobj: {
                type: '',
                errorMsg: ''
            }
        }
    },
    created(){
        
    }
}
</script>
<style lang="stylus">
    omit-line(num=2)
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: num;
        word-break: break-all;
    .book_list_item
        display:block
        height:4.5rem
        margin-bottom:1.25rem
        .img_contain
            position:relative
            width:4.5rem
            height:4.5rem
            img
                width:4.5rem
                height:4.5rem
            .book_count
                font-size:.6rem
                padding:.125rem .3rem
                padding-bottom:.25rem
                color:#fff
                position:absolute
                right:.2rem
                bottom:.2rem
                background:rgba(0,0,0,0.5)
                border-radius:.6rem
        .book_conent_title
            height:100%
            margin-left:5rem
            padding-top:0.1rem
            position:relative
            p
                font-size:0.7rem
            .book_conent_title_bottom
                margin-top:.7rem
                font-size:0.6rem
                color:#646464
                omit-line(2)
            .comment_total
                position:absolute
                right:0
                bottom:0
                font-size:0.6rem
                color:#969696
                div
                    display:inline-block
                    width:0.7rem
                    height:0.6rem
                    vertical-align:middle
                    margin-top:0.1rem
                .hert
                    background:url('../assets/images/collect.png') no-repeat
                    background-size:100% 100%
                .collect_click
                    background:url('../assets/images/collect_click.png') no-repeat
                    background-size:100% 100%
                .comment_icon
                    margin-left:3px
                    background:url('../assets/images/comment.png') no-repeat
                    background-size:100% 100%
                span
                    vertical-align:middle
</style>



// WEBPACK FOOTER //
// booklistItem.vue?ffe311fc